export default "__VITE_ASSET__DGVMwmc2__"